import { isArray, isObject } from 'util'

/**
 * 新建dom
 * @param {String} htmlStr
 * @return {HTMLElement}
 */
export function newDom(htmlStr) {
    const dom = document.createElement('div')
    dom.innerHTML = htmlStr
    return dom.children[0]
}

/**
 * 批量绑定事件
 * @param {HTMLElement} dom
 * @param {Array.<String>} events
 * @param {Function | Array.<Function>} handler
 */
export function bindAll(dom, events, handler) {
    if (isArray(handler)) {
        let lastHandler = handler[handler.length - 1]
        events.forEach((e, i) =>
            dom.addEventListener(e, handler[i] || lastHandler)
        )
    } else {
        events.forEach(e => dom.addEventListener(e, handler))
    }
}

/**
 * 批量绑定事件
 * @param {HTMLElement} dom
 * @param {Array.<Array>} events [["click","mouseover"], [handler1]]
 */
export function bindAll2(dom, events) {
    for (const [eventNames, handlers] of events) {
        bindAll(dom, eventNames, handlers)
    }
}

/**
 * 批量解绑事件
 * @param {HTMLElement} dom
 * @param {Array.<String>} events
 * @param {Function | Array.<Function>} handler
 */
export function unBindAll(dom, events, handler) {
    if (isArray(handler)) {
        let lastHandler = handler[handler.length - 1]
        events.forEach((e, i) =>
            dom.removeEventListener(e, handler[i] || lastHandler)
        )
    } else {
        events.forEach(e => dom.removeEventListener(e, handler))
    }
}

/**
 * 批量解绑事件
 * @param {HTMLElement} dom
 * @param {Array.<Array>} events [["click","mouseover"], [handler1]]
 */
export function unBindAll2(dom, events) {
    for (const [eventNames, handlers] of events) {
        unBindAll(dom, eventNames, handlers)
    }
}

function each(val, handler) {
    if (isArray(val)) {
        val.forEach(handler)
    } else if (isObject(val)) {
        for (const key in val) {
            if (val.hasOwnProperty(key)) {
                const value = val[key]
                handler(key, value)
            }
        }
    } else {
        handler(val)
    }
}

/**
 * 添加class
 * @param {HTMLElement} dom
 * @param {*} className
 */
export function addClass(dom, className) {
    each(className, v => dom.classList.add(v))
}

/**
 * 移除class
 * @param {HTMLElement} dom
 * @param {*} className
 */
export function removeClass(dom, className) {
    each(className, v => dom.classList.remove(v))
}

/**
 * 添加style
 * @param {HTMLElement} dom
 */
export function addStyle(dom, ...rest) {
    if (rest.length === 1) {
        each(rest[0], (key, value) => (dom.style[key] = value))
    } else {
        dom.style[rest[0]] = rest[1]
    }
}

/**
 * 移除style
 * @param {HTMLElement} dom
 */
export function removeStyle(dom, val) {
    each(val, key => (dom.style[key] = ''))
}
